import type { ComponentType } from 'react';
import { NavLink } from 'react-router-dom';
import {
  Boxes,
  Building2,
  ClipboardList,
  Gavel,
  Landmark,
  LayoutDashboard,
  Layers,
  PackageSearch,
  Scale,
  Settings,
  Store,
  Tags,
  Truck,
  Users,
  Wallet,
  type LucideProps,
} from 'lucide-react';
import '@/admin/components/sidebar.scss';

interface NavItem {
  to: string;
  label: string;
  icon: ComponentType<LucideProps>;
  end?: boolean;
}

interface NavGroup {
  label: string;
  items: NavItem[];
}

const NAV_GROUPS: NavGroup[] = [
  {
    label: 'Overview',
    items: [{ to: '/admin', label: 'Dashboard', icon: LayoutDashboard, end: true }],
  },
  {
    label: 'Marketplace',
    items: [
      { to: '/admin/companies', label: 'Companies', icon: Building2 },
      { to: '/admin/orders', label: 'Orders', icon: ClipboardList },
      { to: '/admin/categories', label: 'Categories', icon: Layers },
    ],
  },
  {
    label: 'Materials',
    items: [
      { to: '/admin/material-stores', label: 'Stores', icon: Store },
      { to: '/admin/material-requests', label: 'Requests', icon: PackageSearch },
      { to: '/admin/supplier-orders', label: 'Supplier orders', icon: Truck },
      { to: '/admin/material-disputes', label: 'Material disputes', icon: Scale },
      { to: '/admin/material-catalog', label: 'Catalog', icon: Boxes },
      { to: '/admin/material-categories', label: 'Material categories', icon: Tags },
    ],
  },
  {
    label: 'Finance',
    items: [
      { to: '/admin/withdrawals', label: 'Withdrawals', icon: Wallet },
      { to: '/admin/bank-accounts', label: 'Bank accounts', icon: Landmark },
      { to: '/admin/disputes', label: 'Disputes', icon: Gavel },
    ],
  },
  {
    label: 'Administration',
    items: [
      { to: '/admin/users', label: 'Users', icon: Users },
      { to: '/admin/settings', label: 'Settings', icon: Settings },
    ],
  },
];

function Sidebar() {
  return (
    <nav className="admin-sidebar">
      <div className="admin-sidebar__brand">
        <span className="admin-sidebar__mark">H</span>
        <span className="admin-sidebar__brand-text">
          <div className="admin-sidebar__brand-name">Hayshen</div>
          <div className="admin-sidebar__brand-sub">Admin Console</div>
        </span>
      </div>

      {NAV_GROUPS.map((group) => (
        <div className="admin-sidebar__group" key={group.label}>
          <div className="admin-sidebar__group-label">{group.label}</div>
          <ul>
            {group.items.map(({ to, label, icon: Icon, end }) => (
              <li key={to}>
                <NavLink to={to} end={end} className={({ isActive }) => (isActive ? 'is-active' : undefined)}>
                  <Icon size={18} />
                  <span>{label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
}

export default Sidebar;
